import React , { Component } from 'react';
import {list,getTags} from "../services/S3";
import {parseList,parseKey} from "../services/S3XmlParser";
import Curve from "./Curve";
import ProductDownloads from './ProductDownloads';
import ProgressCircle from './ProgressCircle';

export default class Downloads extends Component {
    state={
        schoolDownloads:[],
        homeDownloads:[]
    };
    schoolProducts=['school','demo_school'];
    homeProducts=['home-international','vna','home'];
    updateArrays=(element)=>{
        if(!element.product)return;
        if(this.schoolProducts.indexOf(element.product)>=0 || element.product.indexOf('school')>=0){
            this.setState({schoolDownloads:[...this.state.schoolDownloads,element]});
        }
        if(this.homeProducts.indexOf(element.product)>=0 || element.product.indexOf('home')>=0){
            this.setState({homeDownloads:[...this.state.homeDownloads,element]});
        }
    };
    init=()=>{
        list((res) => {
            const keys = parseList(res);
            console.log(keys);
            keys.forEach(key => {
                getTags(key, (res) =>{
                    const obj=parseKey(key,res);
                    this.updateArrays(obj);
                    console.log(obj);
                    }
                    , (code, res) => {
                        console.log(code);
                        console.log(res);
                })
            })
        }, (code, res) => {
            console.log(code);
            console.log(res)
        });
    };
    constructor(props) {
        super(props);
        this.init();
    }
    render() {
        return <div>
            <Curve cname="downloads--top" height="180" color="#1a1246"/>
            <div className='fixed-container'>
                <h2 className='downloads--caption'>Загрузки</h2>
            </div>

            <div className='downloads--body'>
                <ProductDownloads keys={this.state.schoolDownloads} caption='Для школы'/>
                <ProductDownloads keys={this.state.homeDownloads} caption='Для семьи'/>
                {this.state.schoolDownloads.length===0 && this.state.homeDownloads.length===0 ?
                <ProgressCircle/> : null}
            </div>
        </div>
    }
}
